/* ==========================================================================
   OSERE — Aparición del pie

   Las columnas suben y aparecen al entrar en pantalla, escalonadas.

   POR QUÉ EL ESTADO INICIAL LO PONE EL JS Y NO EL CSS.
   Si el `opacity: 0` viviera en la hoja, bastaría con que este archivo no
   llegara a ejecutarse —bloqueado por una extensión, un error de red, un
   navegador que no soporta IntersectionObserver— para que el pie entero
   quedara invisible de forma permanente. Poniendo el atributo desde aquí, la
   ausencia de JS significa «se ve todo», que es el fallo correcto.

   Es el mismo criterio que el vídeo del hero: la mejora se añade, nunca se
   resta de un estado que ya funciona.
   ========================================================================== */

(function () {
  'use strict';

  var pie = document.querySelector('[data-os-pie]');
  if (!pie) return;

  // Movimiento reducido: no se toca nada. El CSS también lo neutraliza, pero
  // ni siquiera merece la pena montar el observer.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Sin IntersectionObserver tampoco se hace nada: se ve todo desde el principio.
  if (!('IntersectionObserver' in window)) return;

  /* Qué se revela. Se eligen bloques con entidad propia, no cada enlace: una
     cascada de ocho elementos se lee como un truco, y además alarga la espera
     hasta que el último es legible. */
  var piezas = pie.querySelectorAll(
    '.footer-block, .os-pie__legal, .footer__copyright, .os-pie__firma'
  );
  if (!piezas.length) return;

  var ESCALON = 70; // ms entre una pieza y la siguiente

  Array.prototype.forEach.call(piezas, function (el, i) {
    el.setAttribute('data-os-revelar', '');
    el.style.setProperty('--os-retardo', i * ESCALON + 'ms');
  });

  var observer = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.setAttribute('data-os-visible', '');
        // Una vez visible, deja de observarse: el pie no se re-anima al subir
        // y volver a bajar, que es lo que convierte un detalle en un tic.
        observer.unobserve(e.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  Array.prototype.forEach.call(piezas, function (el) {
    observer.observe(el);
  });

  /* Red de seguridad: si por lo que sea el observer no ha disparado cuando la
     página lleva un rato cargada y el pie ya está en pantalla, se revela a
     mano. Cubre el caso de una pestaña que nace oculta —donde el callback
     inicial llega con isIntersecting=false— y deja el pie en blanco. */
  window.addEventListener(
    'load',
    function () {
      setTimeout(function () {
        Array.prototype.forEach.call(piezas, function (el) {
          if (el.hasAttribute('data-os-visible')) return;
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) {
            el.setAttribute('data-os-visible', '');
            observer.unobserve(el);
          }
        });
      }, 1200);
    },
    { once: true }
  );
})();
